export function createUnitIndexNode(doc: Document, index: number) {
  const unitIndexNode = doc.createElement('UnitIndex');
  unitIndexNode.textContent = index.toString();
  return unitIndexNode;
}
